import React from 'react';

import getReadibilityColor from '../../utils/styles/utils/readibility';
import LayoutProvider from '../../utils/styles/layout/LayoutProvider';
import useLayout from '../../utils/styles/layout/useLayout';
import useTheme from '../../utils/styles/theme/useTheme';

type Props = {
  style?: React.CSSProperties;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>;

const Text: React.FC<Props> = ({ style, ...rest }) => {
  const { backgroundColor, text } = useLayout();
  const theme = useTheme();
  return (
    <LayoutProvider value={{ text }}>
      <span
        css={`
          color: ${getReadibilityColor(backgroundColor, theme)};
          ${text}
          ${style}
        `}
        {...rest}
      />
    </LayoutProvider>
  );
};

export default Text;
